import { render, staticRenderFns } from "./organizacoes.vue?vue&type=template&id=2d96e1f4&"
import script from "./organizacoes.vue?vue&type=script&lang=js&"
export * from "./organizacoes.vue?vue&type=script&lang=js&"
import style0 from "./organizacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports